import type { FaireProductEntity } from "../../entity_types/product";

export const p_n5c6azucu8: FaireProductEntity = {
  token: "p_n5c6azucu8",
  type: "product",
  name: "Pickles! Charms",
  brandToken: "b_h93v6v8mbm",
  brandName: "Aurora Boheme",
  imageUrl:
    "https://cdn.faire.com/fastly/af32fcfda1055a59fb0cda4e51d9866da3dcc504ce53e91752a8a5520fe820ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c21dda92f5bf0ce1a662d18168608c4f903b8831154d352fcd76566554a07b62.jpeg",
  ],
  priceDollars: 12.47,
  description: "",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:12.585Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
